import React from "react";

export default function Logo({ className = "h-9 w-9" }) {
  return (
    <svg className={className} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <defs>
        <linearGradient id="lg" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#0e2740" />
          <stop offset="1" stopColor="#1f4a72" />
        </linearGradient>
      </defs>
      <rect width="64" height="64" rx="12" fill="url(#lg)" />
      <g fill="#e9c46a">
        <rect x="12" y="24" width="8" height="28" />
        <rect x="22" y="14" width="10" height="38" />
        <rect x="34" y="20" width="7" height="32" />
        <rect x="43" y="28" width="9" height="24" />
      </g>
      <g fill="#0e2740">
        <rect x="24" y="18" width="2" height="2" />
        <rect x="28" y="18" width="2" height="2" />
        <rect x="24" y="24" width="2" height="2" />
        <rect x="28" y="24" width="2" height="2" />
        <rect x="24" y="30" width="2" height="2" />
        <rect x="28" y="30" width="2" height="2" />
        <rect x="24" y="36" width="2" height="2" />
        <rect x="28" y="36" width="2" height="2" />
        <rect x="24" y="42" width="2" height="2" />
        <rect x="28" y="42" width="2" height="2" />
        <rect x="36" y="24" width="2" height="2" />
        <rect x="36" y="30" width="2" height="2" />
        <rect x="36" y="36" width="2" height="2" />
        <rect x="36" y="42" width="2" height="2" />
        <rect x="14" y="30" width="2" height="2" />
        <rect x="14" y="36" width="2" height="2" />
        <rect x="14" y="42" width="2" height="2" />
        <rect x="46" y="34" width="2" height="2" />
        <rect x="46" y="40" width="2" height="2" />
        <rect x="46" y="46" width="2" height="2" />
      </g>
    </svg>
  );
}
